(() => {
  const loader = document.querySelector('[data-md-preloader-el]');
  const root = document.documentElement;
  if (!loader || root.classList.contains('md-preloader-skip') || window.Shopify?.designMode) {
    loader?.remove();
    root.classList.remove('md-preloading');
    return;
  }

  const toRgb = (color) => {
    try {
      const ctx = document.createElement('canvas').getContext('2d', { willReadFrequently: true });
      ctx.fillStyle = color;
      ctx.fillRect(0, 0, 1, 1);
      const [r, g, b] = ctx.getImageData(0, 0, 1, 1).data;
      return `rgb(${r}, ${g}, ${b})`;
    } catch (error) {
      return color;
    }
  };

  const speed = Number(loader.dataset.speed) || 1;
  const ms = (value) => value / speed;
  const EASE = {
    inOut4: 'cubic-bezier(0.76, 0, 0.24, 1)',
    inOut2: 'cubic-bezier(0.45, 0, 0.55, 1)',
    out4: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
  };

  let seen = false;
  try {
    seen = Boolean(sessionStorage.getItem('md-preloader-seen'));
    sessionStorage.setItem('md-preloader-seen', '1');
  } catch (error) {}

  window.md?.lenis?.stop();

  const number = loader.querySelector('[data-md-preloader-number]');
  const counter = loader.querySelector('.md-preloader__counter');
  const counterScale = loader.querySelector('.md-preloader__counter-scale');
  const counterText = loader.querySelector('.md-preloader__counter-text');
  const mark = loader.querySelector('.md-preloader__mark');
  const clones = [...loader.querySelectorAll('.md-preloader__clone')];
  const paths = clones.flatMap((clone) => [...clone.querySelectorAll('path')]);
  const probe = document.createElement('span');
  loader.append(probe);
  const resolveColor = (value) => {
    probe.style.color = value || 'var(--md-sys-color-primary)';
    return toRgb(getComputedStyle(probe).color);
  };
  const fills = new Map(paths.map((path) => [path, resolveColor(path.dataset.fill)]));
  probe.remove();

  const size = mark.getBoundingClientRect().width || 150;
  const base = (Math.hypot(innerWidth, innerHeight) / size) * 1.15;
  const start = (i) => `rotate(90deg) scale(${(base + i * base * 0.07).toFixed(3)})`;

  const wait = (time) => new Promise((resolve) => setTimeout(resolve, time));
  const finished = (animations) => Promise.all(animations.map((animation) => animation.finished));

  const runCounter = () => {
    const duration = ms(2000);
    const pad = parseFloat(getComputedStyle(counter).right) || 24;
    const travel = -(counter.getBoundingClientRect().left - pad);
    const bezier = (t) => (t < 0.5 ? 8 * t ** 4 : 1 - (-2 * t + 2) ** 4 / 2);
    const begin = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - begin) / duration);
      number.textContent = Math.round(bezier(t) * 100);
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);

    counter.animate([{ transform: `translateX(${travel}px)` }, { transform: 'none' }], { duration, easing: EASE.inOut4, fill: 'both' });
    counterScale.animate([{ transform: 'scale(1)' }, { transform: 'scale(2)' }], { duration, easing: EASE.inOut4, fill: 'both' });
    return wait(duration + ms(100)).then(() =>
      counterText.animate([{ transform: 'none' }, { transform: 'translateY(200%)' }], { duration: ms(800), easing: EASE.inOut2, fill: 'forwards' }).finished
    );
  };

  const runMarks = async (short) => {
    if (!short) {
      await finished(
        clones.map((clone, i) => {
          const progress = i / (clones.length - 1);
          return clone.animate([{ transform: start(i) }, { transform: 'none' }], {
            duration: ms(1200),
            delay: ms(300 * progress * progress),
            easing: EASE.inOut4,
            fill: 'both',
          });
        })
      );
    } else {
      clones.forEach((clone) => clone.animate([{ transform: 'none' }], { fill: 'forwards' }));
    }

    const fill = { duration: ms(400), easing: EASE.inOut2, fill: 'forwards' };
    await finished([
      ...paths.map((path) => path.animate([{ fill: fills.get(path), stroke: fills.get(path) }], fill)),
      ...clones.map((clone) => clone.animate([{ transform: 'scale(1.2)' }], fill)),
    ]);

    const fly = { duration: ms(800), easing: EASE.out4, fill: 'forwards' };
    await finished([
      ...clones.slice(9).map((clone) => clone.animate([{ opacity: 0 }], { ...fly, duration: ms(200) })),
      ...clones.slice(1, 5).map((clone, j) =>
        clone.animate([{ transform: `translate(${-79 * (j + 1)}%, ${-63 * (j + 1)}%) scale(1.2)` }], { ...fly, delay: ms((3 - j) * 25) })
      ),
      ...clones.slice(5, 9).map((clone, j) =>
        clone.animate([{ transform: `translate(${79 * (j + 1)}%, ${63 * (j + 1)}%) scale(1.2)` }], { ...fly, delay: ms(j * 25) })
      ),
    ]);
  };

  const exit = async () => {
    await loader.animate([{ transform: 'none' }, { transform: 'translateY(-100%)' }], { duration: ms(500), easing: EASE.inOut2, fill: 'forwards' }).finished;
    loader.remove();
    root.classList.remove('md-preloading');
    window.md?.lenis?.start();
    document.dispatchEvent(new CustomEvent('md:preloader:done'));
  };

  const play = async () => {
    clones.forEach((clone, i) => (clone.style.transform = start(i)));
    mark.classList.add('is-ready');

    if (seen) {
      counter.hidden = true;
      await runMarks(true);
    } else {
      const counterDone = runCounter();
      await wait(ms(1900));
      await Promise.all([runMarks(false), counterDone]);
    }
    await exit();
  };

  play().catch(() => {
    loader.remove();
    root.classList.remove('md-preloading');
  });
})();
